import React from 'react'
import styles from './styles.module.scss'
import FooterLinksColumns from './LinksColumns'
import FooterBaseLinks from './FooterBaseLinks'
import ContactInfo from './ContactInfo'
import PaymentCardOptions from './PaymentCardOptions'
import CountryCurrencySwitcher from './CountryCurrencySwitcher'

function Footer() {
  return (
    <footer id="footer" className={styles.Footer}>
      <div className={styles.FooterContainer}>
        <div className={styles.FooterLinks}>
          <ContactInfo />
          <CountryCurrencySwitcher />
          <FooterLinksColumns />
        </div>
        <div className={styles.FooterBase}>
          <FooterBaseLinks />
          <PaymentCardOptions />
        </div>
      </div>
    </footer>
  )
}

export default Footer
